import type { MailboxInfo } from 'owa-client-types';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isOfflineSyncEnabled } from './isOfflineSyncEnabled';

export function isOfflineMailDataEnabled(mailboxInfo?: MailboxInfo): boolean {
    return isOfflineSyncEnabled(mailboxInfo) && isFeatureEnabled('fwk-offline-mail');
}
